import { useAtomValue, useUpdateAtom } from "jotai/utils"

import { atom } from "jotai"
import { useEffect } from "react"

type CellDialog =
  | "exclusions"
  | "digital_calculator"
  | "rate_card"
  | "spots_plan"
  | "passthrough"
  | "taxes"
  | undefined

type FieldInfo = {
  rowId: string
  dataKey: string
  primaryKey?: string
  semantic?: string
}

type CellDialogStore =
  | {
      type: CellDialog
      fieldInfo: FieldInfo
      anchor?: HTMLDivElement | HTMLButtonElement | null
    }
  | undefined

const cellDialog = atom<CellDialogStore>(undefined)

export function useCellDialog() {
  const value = useAtomValue(cellDialog)
  const update = useUpdateAtom(cellDialog)

  const onChange = (value: CellDialogStore) => update(value)

  const onClose = () => update(undefined)

  useEffect(() => {
    return () => {
      update(undefined)
    }
  }, [update])

  return { value, onChange, onClose }
}
